<template>
	<div class="my-6">
		<div v-if="newsItem.title_image" class="max-w-[360px] mx-auto mb-4">
			<span v-if="newsItem.title_image_url">
				<a v-bind:href="newsItem.title_image_url" target="_blank">
					<img :src="imageUrl" class="mx-auto" />
				</a>
			</span>
			<span v-else>
				<img :src="imageUrl" class="mx-auto" />
			</span>
		</div>
		<h3 class="text-lg font-semibold text-gray-900">{{ newsItem.title }}</h3>
		<span class="whitespace-pre-line" v-html="newsItem.text"></span>
	</div>
</template>

<script>
export default {
	props: {
		newsItem: {
			type: Object,
			required: true,
		},
	},
	computed: {
		imageUrl() {
			let updatedAt = new Date(this.newsItem.updated_at);
			return (
				window.baseUrl +
				"/market-news/item/" +
				this.newsItem.id +
				"/image?ts=" +
				updatedAt.getTime()
			);
		},
	},
};
</script>
